export function getNotificationBannerCookieName(slug: string) {
  return `notification-banner-${slug}`
}

export function setNotificationBannerCookie(slug: string, hash: string) {
  document.cookie = `${getNotificationBannerCookieName(slug)}=${hash}; expires=Fri, 29 Dec 2028 23:59:59 GMT; path=/; domain=${document.domain}`
}
